export default {"src":"/_next/static/media/deposit.72cc09e0.svg","height":205,"width":195};